import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./style.css";
import OfferBook from "./offerBook";
import { AddOffer } from "../../../services/offerService";
import { toastMessage } from "../../common/toast";

function MakeOfferModal({
  openModal,
  HideModal,
  booklist,
  handleBookSelection,
  selectedBook,
  bookID,
  OnSwap,
  token,
}) {
  const user = useSelector((state) => state.root.user);
  const [loader, setLoader] = useState(false);
  const confirmOffer = async () => {
    setLoader(true);
    console.log(token);
    let obj = {
      offeredBook: bookID,
      offeredToken: token,
      offeringBook: selectedBook._id,
      offeringToken: selectedBook.token,
    };
    await AddOffer(user?.token, obj)
      .then((res) => {
        if (res.statusText === "OK") {
          toastMessage("Offer made Successfuly", "success");
          HideModal();
          OnSwap();
          setLoader(false);
        } else {
          setLoader(false);
          toastMessage(res.data, "error");
        }
      })
      .catch((error) => {
        toastMessage(error.message, "error");
        setLoader(false);
      });
  };
  return (
    <>
      <Modal
        size="lg"
        backdrop="static"
        show={openModal}
        onHide={HideModal}
        centered
      >
        <button
          type="button"
          className="close custom-modal-close"
          onClick={HideModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="login-form" style={{ width: "100%" }}>
          <div className="make-offer-container overflow-auto">
            <div className="d-flex flex-row flex-wrap">
              {booklist?.map((item, key) => {
                return (
                  <OfferBook
                    key={key}
                    item={item}
                    isSelected={item?._id == selectedBook?._id}
                    handleBookSelection={handleBookSelection}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center pb-4">
          <button className="make-offer-btn2" onClick={HideModal}>
            Cancel
          </button>
          {loader ? (
            <button className="make-offer-btn1" onClick={confirmOffer}>
              <Spinner animation="grow" size="sm" />
            </button>
          ) : (
            <button className="make-offer-btn1" onClick={confirmOffer}>
              Confirm
            </button>
          )}
        </div>
      </Modal>
    </>
  );
}

export default MakeOfferModal;
